/**
 * German dye names the retired 4.x PaletteService could have stored, mapped to
 * stainIDs, for the one-time legacy palette migration in collection-service.ts.
 *
 * Core 5.16.0 adopted XIVAPI's German names (PR #390): 118 lost their
 * inflected ending, and the metallic ones also capitalize the color
 * ("Schneeweißer" became "Schneeweiß", "Metallic silberner" became
 * "Metallic Silber"), so a 4.x palette saved under
 * the German UI would otherwise drop those companions. The table also keeps
 * "Perlmutt-", Pearl White's name before 2026-09-03.
 *
 * FROZEN: this records names users saved in the past. Never regenerate it from
 * the current locale data. Built once (2026-10-31) from `main` at 13c386e5 and
 * the 4.x-era de.json at 7500ba2e~1. Keys are lowercase, as the migration
 * compares them. Once core 5.16.0's names are in place, none equals a current
 * dye name in any locale; before that, 118 are the current German names, on
 * the same stainIDs.
 */
export const LEGACY_GERMAN_DYE_NAMES: ReadonlyMap<string, number> = new Map<string, number>([
  ['schneeweißer', 1],
  ['aschgrauer', 2],
  ['goobbuegrauer', 3],
  ['schiefergrauer', 4],
  ['anthraziter', 5],
  ['rußschwarzer', 6],
  ['rosaroter', 7],
  ['rolanbeerenroter', 9],
  ['dalamudroter', 10],
  ['rostroter', 11],
  ['weinroter', 12],
  ['blutroter', 14],
  ['abendroter', 16],
  ['tafelbergroter', 17],
  ['borkenbrauner', 18],
  ['schokoladenbrauner', 19],
  ['rotbrauner', 20],
  ['koboldbrauner', 21],
  ['korkbrauner', 22],
  ['qiqirnbrauner', 23],
  ['opo-opobrauner', 24],
  ['steinbockbrauner', 25],
  ['kürbisoranger', 26],
  ['eichelbrauner', 27],
  ['obstbrauner', 28],
  ['kastanienbrauner', 29],
  ['kartonbrauner', 30],
  ['schieferbrauner', 31],
  ['maulwurfsbrauner', 32],
  ['lehmbrauner', 33],
  ['knochenweißer', 34],
  ["ul'dahbrauner", 35],
  ['wüstengelber', 36],
  ['honiggelber', 37],
  ['maisgelber', 38],
  ['coeurlgelber', 39],
  ['cremegelber', 40],
  ['halataligelber', 41],
  ['rosinenbrauner', 42],
  ['schlammgrüner', 43],
  ['sylphengrüner', 44],
  ['limettengrüner', 45],
  ['moosgrüner', 46],
  ['grasgrüner', 47],
  ['olivgrüner', 48],
  ['sumpfgrüner', 49],
  ['apfelgrüner', 50],
  ['kaktusgrüner', 51],
  ['jägergrüner', 52],
  ['ochugrüner', 53],
  ['adaman-taimaigrüner', 54],
  ['nophicagrüner', 55],
  ['waldgrüner', 56],
  ['mintgrüner', 57],
  ['türkiser', 58],
  ['morbolgrüner', 59],
  ['eisblauer', 60],
  ['himmelblauer', 61],
  ['seenebelblauer', 62],
  ['pfauenblauer', 63],
  ['rhotanoblauer', 64],
  ['leichenblauer', 65],
  ['erdseimblauer', 66],
  ['indigoblauer', 67],
  ['tintenblauer', 68],
  ['raptorenblauer', 69],
  ['othardblauer', 70],
  ['sturmblauer', 71],
  ['nichtsblauer', 72],
  ['königsblauer', 73],
  ['mitternachtsblauer', 74],
  ['schattenblauer', 75],
  ['tiefblauer', 76],
  ['lavendelblauer', 77],
  ['düstervioletter', 78],
  ['johannisbeerenvioletter', 79],
  ['irisvioletter', 80],
  ['weintraubenvioletter', 81],
  ['pflaumenvioletter', 84],
  ['königsvioletter', 85],
  ['rubinroter', 86],
  ['kirschpinker', 87],
  ['kanariengelber', 88],
  ['vanillegelber', 89],
  ['dragoonblauer', 90],
  ['cyanblauer', 91],
  ['cermetgrauer', 92],
  ['perlmutt-', 93],
  ['metallic messingfarbener', 94],
  ['karmesinroter', 95],
  ['neonpinker', 96],
  ['knalloranger', 97],
  ['neongelber', 98],
  ['neongrüner', 99],
  ['azurblauer', 100],
  ['wolkenweißer', 101],
  ['rabenschwarzer', 102],
  ['dunkelroter', 104],
  ['dunkelbrauner', 105],
  ['pastellgrüner', 106],
  ['dunkelgrüner', 107],
  ['pastellblauer', 108],
  ['dunkelblauer', 109],
  ['pastellvioletter', 110],
  ['dunkelvioletter', 111],
  ['metallic silberner', 112],
  ['metallic goldener', 113],
  ['metallic roter', 114],
  ['metallic orangefarbener', 115],
  ['metallic gelber', 116],
  ['metallic grüner', 117],
  ['metallic himmelblauer', 118],
  ['metallic blauer', 119],
  ['metallic violetter', 120],
  ['purpurvioletter', 121],
  ['metallic pinker', 122],
  ['metallic rubinroter', 123],
  ['metallic kobaltgrüner', 124],
  ['metallic dunkelblauer', 125],
]);
